import { useMemo } from 'react';

import { findStaticDataFetcherItemByValue, StaticDataFetcherItem, useStaticDataProvider } from '@hh.ru/magritte-ui';
import { Select } from '@hh.ru/magritte-ui-select';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { SearchPeriodOption, PossibleSearchPeriod } from 'src/types/search/resume/criteria';

interface SearchPeriodProps {
    onChange: (value: PossibleSearchPeriod) => void;
    value: PossibleSearchPeriod;
}

const TrlKeys = {
    customInterval: 'search.period.-1',
    [SearchPeriodOption.AllTime]: 'search.period.0',
    [SearchPeriodOption.Day]: 'search.period.1',
    [SearchPeriodOption.ThreeDays]: 'search.period.3',
    [SearchPeriodOption.Week]: 'search.period.7',
    [SearchPeriodOption.Month]: 'search.period.30',
    [SearchPeriodOption.Year]: 'search.period.365',
};

const SearchPeriod: TranslatedComponent<SearchPeriodProps> = ({ onChange, value, trls }) => {
    const values = useSelector((state) => state.resumeSearchDictionaries.search_period);

    const searchPeriodValues = useMemo(
        () => (value === 'customInterval' ? [...(values || []), value] : values || []),
        [value, values]
    );

    const items: StaticDataFetcherItem[] = useMemo(
        () =>
            searchPeriodValues.map((value) => ({
                text: trls[TrlKeys[value]],
                value,
            })),
        [searchPeriodValues, trls]
    );

    const provider = useStaticDataProvider(items);

    if (!values) {
        return null;
    }

    return (
        <Select
            type="radio"
            name="search_period"
            value={findStaticDataFetcherItemByValue(value, items)}
            dataProvider={provider}
            widthEqualToActivator={false}
            bottomSheetHeight="content"
            plain
            renderHeader={() => undefined}
            triggerProps={{
                size: 'xsmall',
                'data-qa': 'resume_search_period',
            }}
            onChange={(item) => {
                onChange(item.value as PossibleSearchPeriod);
            }}
        />
    );
};

export default translation(SearchPeriod);
